<template>
  <div class="contact-float">
    <!-- 全局留言触发按钮 -->
    <button type="button" class="cf-trigger" @click="open" :title="$t('contact.floatCta')" :aria-label="$t('contact.floatCta')">
      <svg viewBox="0 0 24 24" width="26" height="26" fill="currentColor" aria-hidden="true">
        <path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z"/>
      </svg>
    </button>

    <!-- 居中留言弹窗 -->
    <el-dialog
      :visible.sync="visible"
      :title="$t('contact.floatTitle')"
      width="560px"
      custom-class="cf-dialog"
      append-to-body
      :close-on-click-modal="false"
      @closed="onClosed">
      <p class="cf-tip">{{ $t('contact.floatTip') }}</p>
      <el-form :model="form" :rules="rules" ref="form" label-position="top">
        <div class="cf-row">
          <el-form-item :label="$t('contact.name')" prop="name">
            <el-input v-model="form.name" :placeholder="$t('contact.name')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('contact.email')" prop="email">
            <el-input v-model="form.email" :placeholder="$t('contact.email')"></el-input>
          </el-form-item>
        </div>
        <div class="cf-row">
          <el-form-item :label="$t('contact.phone')" prop="phone">
            <el-input v-model="form.phone" :placeholder="$t('contact.phone')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('contact.subject')" prop="subject">
            <el-input v-model="form.subject" :placeholder="$t('contact.subject')"></el-input>
          </el-form-item>
        </div>
        <el-form-item :label="$t('contact.message')" prop="message">
          <el-input type="textarea" v-model="form.message" :rows="4" :placeholder="$t('contact.message')"></el-input>
        </el-form-item>
        <button type="button" class="cf-submit" @click="submitForm" :disabled="submitting">
          {{ submitting ? '' : $t('contact.send') }}
          <span v-if="submitting" class="cf-spinner"></span>
        </button>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { submitMessage } from '@/api'
export default {
  name: 'ContactFloat',
  data() {
    return {
      visible: false,
      submitting: false,
      form: { name: '', email: '', phone: '', subject: '', message: '' }
    }
  },
  computed: {
    lang() { return this.$store.state.lang },
    rules() {
      return {
        name: [{ required: true, message: this.$t('contact.required'), trigger: 'blur' }],
        email: [
          { required: true, message: this.$t('contact.required'), trigger: 'blur' },
          { type: 'email', message: this.$t('contact.emailInvalid'), trigger: 'blur' }
        ],
        message: [{ required: true, message: this.$t('contact.required'), trigger: 'blur' }]
      }
    }
  },
  methods: {
    open() { this.visible = true },
    onClosed() {
      this.form = { name: '', email: '', phone: '', subject: '', message: '' }
      if (this.$refs.form) this.$refs.form.clearValidate()
    },
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) return
        this.submitting = true
        try {
          await submitMessage({ ...this.form, lang: this.lang })
          this.$message.success(this.$t('contact.sentSuccess'))
          this.visible = false
        } catch (e) {
          this.$message.error(this.$t('contact.sendFailed'))
        }
        this.submitting = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.contact-float {
  position: fixed; bottom: 30px; right: 30px; z-index: 2000;
}
.cf-trigger {
  width: 60px; height: 60px; border-radius: 50%;
  display: flex; align-items: center; justify-content: center;
  background: #c9a84c; color: #0a0a1a; border: none; cursor: pointer;
  box-shadow: 0 6px 20px rgba(201,168,76,0.4);
  transition: transform 0.3s, box-shadow 0.3s;
  &:hover { transform: scale(1.08); box-shadow: 0 8px 26px rgba(201,168,76,0.55); }
}
.cf-tip { color: rgba(255,255,255,0.55); font-size: 13px; margin: 0 0 18px; }
.cf-row { display: grid; grid-template-columns: 1fr 1fr; gap: 0 16px; }
.cf-submit {
  width: 100%; padding: 14px; margin-top: 4px;
  background: #c9a84c; border: none; border-radius: 4px; color: #0a0a1a;
  font-size: 14px; font-weight: 600; text-transform: uppercase; letter-spacing: 2px;
  font-family: 'Montserrat', sans-serif; cursor: pointer; transition: background 0.3s;
  display: flex; align-items: center; justify-content: center; min-height: 48px;
  &:hover:not(:disabled) { background: #e8d48b; }
  &:disabled { cursor: not-allowed; opacity: 0.85; }
}
.cf-spinner {
  width: 18px; height: 18px; border: 2px solid rgba(10,10,26,0.3);
  border-top-color: #0a0a1a; border-radius: 50%; animation: cfspin 0.7s linear infinite;
}
@keyframes cfspin { to { transform: rotate(360deg); } }

@media (max-width: 520px) {
  .contact-float { bottom: 20px; right: 20px; }
  .cf-trigger { width: 54px; height: 54px; }
  .cf-row { grid-template-columns: 1fr; }
}
</style>

<style lang="scss">
/* Element UI 弹窗深色主题（非 scoped 以覆盖内部类，仅作用于 cf-dialog）
   根选择器用 .el-dialog.cf-dialog 提升具体性，避免被 Element 默认 .el-dialog{background:#fff} 覆盖 */
.el-dialog.cf-dialog {
  background: #101022; border-radius: 10px; overflow: hidden;
  box-shadow: 0 20px 60px rgba(0,0,0,0.5);
  .el-dialog__header { padding: 18px 24px; margin: 0; background: #101022; border-bottom: 1px solid rgba(201,168,76,0.15); }
  .el-dialog__title { color: #fff; font-family: 'Montserrat', sans-serif; letter-spacing: 1px; font-size: 17px; }
  .el-dialog__headerbtn { top: 18px; right: 20px; }
  .el-dialog__close { color: rgba(255,255,255,0.55); font-weight: 400; }
  .el-dialog__close:hover { color: #c9a84c; }
  .el-dialog__body { padding: 22px 24px 24px; background: #101022; }
  .el-form-item__label { color: rgba(255,255,255,0.6); padding-bottom: 4px; }
  .el-input__inner, .el-textarea__inner {
    background: rgba(255,255,255,0.05); border: 1px solid rgba(201,168,76,0.2); color: #fff;
    &::placeholder { color: rgba(255,255,255,0.3); }
  }
  .el-input__inner:focus, .el-textarea__inner:focus { border-color: #c9a84c; }
  .el-form-item.is-error .el-input__inner, .el-form-item.is-error .el-textarea__inner { border-color: #e74c3c; }
  .el-form-item__error { color: #e74c3c; }
}
@media (max-width: 520px) {
  .cf-dialog { width: 92% !important; }
  .cf-dialog .el-dialog__body { padding: 18px; }
}
</style>
